<template>
  <div>
    <div class="text-text-label -mt-3 mb-3 text-xs">{{ $t('label') }}</div>
    <div class="flex space-x-12">
      <div v-for="(type,i) in space_types" :key="i"
           class="flex items-center cursor-pointer group"
           :class="{'opacity-50 pointer-events-none':disabled}"
           @click="$emit('change',type.val)">
        <div class="w-10 h-10 flex items-center justify-center
                    rounded border border-border bg-block text-center mr-4
                    group-hover:border-border-hover
                    transition duration-200">
          <component :is="`icon-${type.icon}`"
                     class="text-icon group-hover:text-icon-hover transition duration-200"
                     :class="{'text-icon-hover':type.val === selected}"/>
        </div>
        <div class="text-text text-sm"
             :class="{'font-medium': type.val === selected}">
          {{ type.name }}
          {{ type.val === 2 && selected === 2 ? ` - ${$tc('members', membersAmount)}` : '' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconAgent from "@/components/icons/operationIcons/IconAgent";
import IconFamily from "@/components/icons/IconFamily";
import IconTeam from "@/components/icons/IconTeam";

export default {
  name: "SpaceTypePicker",
  components: {IconTeam, IconFamily, IconAgent},
  props: {
    selected: {
      type: Number,
      required: true,
      validator: (val) => [1, 2, 3].includes(val)
    },
    membersAmount: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    space_types() {
      return [
        {val: 1, icon: 'agent', name: this.$t('personal'), disabled: false},
        {val: 2, icon: 'family', name: this.$t('family')},
        // {val: 3, icon: 'team', name: this.$t('team')}
      ]
    }
  },
  i18n: {
    messages: {
      en: {
        label: 'Select the type of accounting system',
        personal: 'Personal',
        family: 'Family',
        team: 'Team',
        members: '{n} member | {n} members'
      },
      ru: {
        label: 'Выберите тип системы учета',
        personal: 'Личная',
        family: 'Семья',
        team: 'Команда',
        members: '{n} участников | {n} участник | {n} участника |  {n} участников'
      },
    }
  }
}
</script>